export default "__VITE_ASSET__52add751__"